export { paymentIntension } from './paymentIntension';
